// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__2KcKr","label":"SetPasswdForm_label__11GRc"};